var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Trigger Group")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-trigger-scope", {
                        attrs: { items: _vm.scopes, model: _vm.model.scope },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "scope", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-col", { attrs: { cols: "12", md: "12", sm: "12" } }),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            absolute: false,
                            "close-on-click": true,
                            "close-on-content-click": true,
                            "offset-y": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { small: "", color: "primary" },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v("Add Trigger "),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-2",
                                          attrs: { "x-small": "" },
                                        },
                                        [_vm._v("mdi-text-box")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        _vm._l(_vm.types, function (kind, i) {
                          return _c(
                            "v-list",
                            {
                              key: i,
                              staticClass: "pa-0",
                              attrs: { dense: "" },
                            },
                            [
                              _c(
                                "v-list-item",
                                {
                                  attrs: { dense: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_create(kind)
                                    },
                                  },
                                },
                                [
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(kind.name),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    _vm._l(_vm.items, function (trigger, i) {
                      return _c(
                        "v-chip",
                        {
                          key: i,
                          staticClass: "ma-1",
                          attrs: {
                            color: trigger.visible ? "green" : "blue darken-1",
                            outlined: !trigger.visible,
                            "text-color": trigger.visible ? "white" : "blue",
                            close: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.row_update(trigger)
                            },
                            "click:close": function ($event) {
                              return _vm.row_remove(trigger)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(trigger.kind.name) + " ")]
                      )
                    }),
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [_c("v-divider", { staticClass: "mb-2" })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-trigger-generic", { ref: "trigger_1" }),
      _c("r-trigger-item", { ref: "trigger_2" }),
      _c("r-trigger-quest", { ref: "trigger_3" }),
      _c("r-trigger-talk", { ref: "trigger_4" }),
      _c("r-trigger-item-group", { ref: "trigger_5" }),
      _c("r-trigger-order", { ref: "trigger_6" }),
      _c("r-trigger-tutorial", { ref: "trigger_7" }),
      _c("r-trigger-product", { ref: "trigger_8" }),
      _c("r-trigger-currency", { ref: "trigger_9" }),
      _c("r-trigger-trader", { ref: "trigger_11" }),
      _c("r-trigger-ship", { ref: "trigger_12" }),
      _c("r-trigger-johan", { ref: "trigger_13" }),
      _c("r-trigger-smart-offer", { ref: "trigger_14" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }